"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, use } from "react";
import { invariant } from "@/lib/utils";
import { getMessagesInternal } from "./server";
const IntlClientContext = createContext(null);
export const IntlClientProvider = t0 => {
  const $ = _c(6);
  const {
    messages,
    locale,
    children
  } = t0;
  let t1;
  if ($[0] !== locale || $[1] !== messages) {
    t1 = {
      locale,
      messages
    };
    $[0] = locale;
    $[1] = messages;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <IntlClientContext value={t1}>{children}</IntlClientContext>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const useLocale = () => {
  const intlCtx = use(IntlClientContext);
  invariant(intlCtx, "useLocale must be used within a IntlClientProvider");
  return intlCtx.locale;
};
export const useTranslations = namespaceKey => {
  const intlCtx = use(IntlClientContext);
  invariant(intlCtx, "useTranslations must be used within a IntlClientProvider");
  return getMessagesInternal(namespaceKey, intlCtx.locale, intlCtx.messages);
};